import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Filter,
  ReferenceInput,
  SelectInput
} from 'admin-on-rest/lib/mui';

export const CustomerFilter = (props) => (
  <Filter {...props}>
  <ReferenceInput label="Πωλητής" source="seller" reference="users" alwaysOn>
              <SelectInput optionText="name" />
  </ReferenceInput>

  <SelectInput
  label="Έτος"
  source="year"
  choices={[
    { id: '2018', name: '2018' },
    { id: '2019', name: '2019' },
    { id: '2020', name: '2020' },
  ]}
alwaysOn allowEmpty />

<SelectInput
  label="Μήνας"
  source="month"
  choices={[
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    { id: '6', name: '6' },
    { id: '7', name: '7' },
    { id: '8', name: '8' },
    { id: '9', name: '9' },
    { id: '10', name: '10' },
    { id: '11', name: '11' },
    { id: '12', name: '12' },
  ]}
alwaysOn allowEmpty />

  </Filter>
);

export const TurnoverList = (props) => (
  <List {...props} filters={<CustomerFilter />} title="Tζίρος">
    <Datagrid key={props.code}>
      <TextField label="Ημερα" source="full_date" />
      <TextField label="Πωλητης" source="seller.surname" />
      <TextField label="τζιρος" source="profit" />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/pages/turnover.js